/* eslint-disable camelcase */
import { useCallback, useState } from 'react'

import moment from 'moment'

import { useAnimalStore } from '../../Stores/animalStore'
import { AnimalsSecured } from '../../Types/AnimalStore'
import { PRICE_TYPE } from '../../constants/priceType'
import { t } from '../../i18n'
import { Minus, Plus } from '../Icons'
import { ExpandedRow } from './ExpandedRow'
import {
  Actions,
  ActionsCell,
  AnimalBreedContainer,
  ButtonContainer,
  Cell,
  ChosenPack,
  NamePackPrice,
  Row,
} from './style'

export const AnimalDataRow = ({ animal }: { animal: AnimalsSecured }) => {
  const { animalsList } = useAnimalStore()

  const firstAnimal = animalsList[0].id
  const [expandedRow, setExpandedRow] = useState(firstAnimal === animal.id)

  const handleExpandClick = useCallback(() => {
    setExpandedRow((prevExpanded) => !prevExpanded)
  }, [])

  return (
    <>
      <Row isExpanded={expandedRow}>
        <Cell altCell>
          {animal.name && animal.name}
          {animal.pack?.price && (
            <NamePackPrice>
              €{animal.pack?.price}/
              {PRICE_TYPE?.[animal.pack?.installment as never]}
            </NamePackPrice>
          )}
        </Cell>
        <Cell>
          {animal.birthDate && animal.birthDate !== 'Invalid date'
            ? moment(animal.birthDate).format('DD-MM-YYYY')
            : ''}
        </Cell>
        <Cell>
          {animal.pack?.name}
          {animal.pack?.name && (
            <ChosenPack>{t('pages.step4.chosenPack')}</ChosenPack>
          )}
        </Cell>
        <Cell>
          <AnimalBreedContainer>
            {animal.breed}&nbsp;&nbsp;
          </AnimalBreedContainer>
        </Cell>
        <ActionsCell>
          <Actions>
            <ButtonContainer onClick={() => handleExpandClick()}>
              {expandedRow ? <Minus /> : <Plus />}
            </ButtonContainer>
          </Actions>
        </ActionsCell>
      </Row>
      {expandedRow && <ExpandedRow animal={animal} />}
    </>
  )
}
